import React, { Component } from 'react'
// import MatrixModal from './MatrixModal'
import { nanoid } from 'nanoid'
import { checkTranslation, getObject, paramsToValue, setObject, translate } from '../../utils/useful'
// import Col from '../../kanban/columns/Col'
// import Collapsible from 'react-collapsible'
import MatrixInfoCell from './MatrixInfoCell'
// import StackedField from '../../inputs/StackedField'
// import ActionButton from '../../partials/ActionButton'
// import IntractionActionsList from '../../IntractionActionsList'
// import ActionsBtn from '../../partials/ActionsBtn'

export default class Matrix extends Component {
    state = {

        // topBox: [
        //     { title: "Unassigned", color: "#A6A6A6", },
        //     { title: "To Do", color: "#FF4B4B" },
        // ],

        side: [
            { icon: "/assets/icons/person-empty.svg", title: "(empty)", },
            { icon: "/assets/icons/person.circle.fill.svg", title: "Username", },
        ],

        data: [
            // { name: "Task number 1", priority: 'hight' },
            // { name: "Task number 1", priority: 'hight' },
        ],
        groups: {},
        open: {},
        // key: ['values.EXs1drDdNolhPWtn-QvqL', 'values.Eyhtt0-HwHzOfBKM3YBCz'],
        columns: {},
        rows: {},

    }

    componentDidMount() {
        this.init()
        // if (!this.props.view?.settings?.stacked) {
        //     this.props.openSelectStack()
        // }
    }

    componentDidUpdate(prevProps) {
        // console.log(this.props.view?.settings?.stacked)
        // console.log(this.state.view?.settings?.stacked)

        // console.log(JSON.stringify(this.props.view?.settings?.stacked) != JSON.stringify(prevProps.view?.settings?.stacked))
        if ((this.props.view?.type == 'Matrix' || this.props.view?.type == 'matrix')) {
            // console.log("WQDEJOKQ")
            this.init()
        }
        if (prevProps.data != this.props.data) {
            this.init()
        }

        if (prevProps.headers != this.props.headers) {
            this.init()
        }

    }

    init() {
        // console.log("jj")

        if (this.props.data) {
            // console.log('*Matrix View INIT', this.props.headers)
            // console.log('this.props.view?.settings?.stacked1', this.props.view?.settings)
            // console.log('this.state.view?.settings?.stacked', this.state.view?.settings?.stacked)
            let view = { options: this.props.options }
            this.setState({ view }, () => {
                // console.log("NITIT")
                let keys = this.props.options
                let columns = {}
                let rows = {}

                // console.log('this.props.view, ', this.props.view)
                // console.log('keys, ', keys)

                if (keys?.row && keys?.column) {

                    let columnKey = paramsToValue(null, keys?.column, this.props.headers, 'Current Record', true)
                    let rowKey = paramsToValue(null, keys?.row, this.props.headers, 'Current Record', true)

                    // console.log(columnKey,rowKey)

                    // console.log(this.props.data)

                    columns = this.groupBy(0, this.props.data, [columnKey])
                    // return
                    rows = this.groupBy(0, this.props.data, [rowKey])

                    let columnHeader
                    let rowHeader

                    // console.log(this.props.data)
                    // console.log(columns, rows)
                    // console.log("this.props.headers")
                    // console.log(this.props.headers)


                    if (this.props.headers) {
                        this.props.headers.forEach(header => {
                            if (header.key == columnKey) {
                                columnHeader = header
                            }

                            if (header.key == rowKey) {
                                rowHeader = header
                            }

                        });


                        // this.props.headers.filter(h => h.key === keys?.row)[0]?.information?.items.map(i => columns[i.id] = i)
                        // this.props.headers.filter(h => h.key === keys?.column)[0]?.information?.items.map(i => rows[i.id] = i)

                        // console.log("this.props.data, ", this.props.data)
                        // console.log("temp1, ", rowsTemp)

                        // console.log('columns,', columns)
                        // console.log('rows,', rows)
                        this.setState({ columns, rows, columnHeader, rowHeader }, () => {
                            setTimeout(() => {
                                let groups = this.groupBy(0, this.props.data, [columnKey, rowKey])

                                // console.log("groups, ", groups)

                                this.setState({ groups })
                            }, 100)
                        })

                    }

                }
            })
        }
    }



    groupBy = (keyIndex = 0, data, keys, dontAddData) => {
        // console.log("======= groupBy =========")
        // console.log(keyIndex)

        if (keys && keys.length > 0) {
            if (keyIndex == 0) {
                this.setState({ orgData: this.props.data })
            }

            let group = {}
            let headers = this.props.headers

            if (data) {

                let key = keys[keyIndex]
                let header
                // console.log('matrixheaders', headers)
                headers?.forEach(element => {
                    if (key == element.key) {
                        header = element
                    }
                });

                // console.log(header, key)

                if (Array.isArray(data)) {
                    data.forEach(element => {
                        // console.log(element,key)
                        let value = getObject(element, key)
                        // console.log(value)

                        if (Array.isArray(value)) {
                            value = value[value.length - 1]
                        }


                        let groupKey = value?._id ?? value

                        if (groupKey == null || groupKey == undefined || groupKey == '') {
                            groupKey = "*undefined"
                            value = '{{lang}}Undefined'
                        }

                        // if (value && header.type == 'SelectInput') {
                        //     value = getObject(value, header?.information?.fields?.title)
                        // } else {
                        //     value = String(value)
                        // }

                        // console.log("groupKey, ", groupKey)

                        if (group[groupKey] == null) {
                            // console.log("NEWWW")
                            group[groupKey] = { data: [], fullData: element, info: value, header, id: nanoid() }
                        }
                        if (!dontAddData) {
                            group[groupKey].data.push(element)
                        }
                    });
                }
                if (keyIndex != keys.length - 1) {

                    for (const [groupKey, groupValues] of Object.entries(group)) {
                        group[groupKey] = { header, id: nanoid(), data: this.groupBy(keyIndex + 1, groupValues.data, keys, dontAddData) }
                    }
                }
                // console.log(group)
                if (keyIndex == 0) {
                    this.setState({ dataGroup: group })
                }
                // console.log('group======', group)
                // this.kanbanMaker(group, cb)

                return group

            }
        }
    }

    collaps = (id) => {
        let open = this.state.open
        open[id] = !open[id]
        this.setState({ open })

    }

    actionClicked = (prop, data, index) => {
        this.props.functionsHandler('collection', prop, data, index)
    }


    openSelectStack = () => {
        if (this.props.openSelectStack) {
            this.props.openSelectStack()
        } else {
            console.log(this.props.functionsHandler)

            if (this.props.functionsHandler) {
                this.props.functionsHandler(null, 'showConfig')
            }
        }
    }




    render() {
        const { options: stacked, width: propWidth = 0 } = this.props;
      
        // --- Responsive knobs
        const isMobile = (propWidth || 0) < 768;          // md breakpoint
        const colMin = isMobile ? 140 : 180;              // column min width
        const rowHeaderW = isMobile ? 120 : 140;          // left header width
        const fontSm = isMobile ? 12 : 14;
      
        // --- Safe entries
        const columnsEntries = this.state.columns ? Object.entries(this.state.columns) : [];
        const rowsEntries = this.state.rows ? Object.entries(this.state.rows) : [];
      
        // --- Content width calc
        let neededWidth = columnsEntries.length
          ? (columnsEntries.length * colMin) + rowHeaderW
          : 200;
      
        let contentWidth = (propWidth > neededWidth || isMobile) ? '100%' : neededWidth;
      
        return (
          <div className='h-100 w-100 position-relative'>
      
            {(stacked && stacked.row && stacked.column) ? (
              <>
                <div
                  ref={el => this.mainContainer = el}
                  className='w-100 window-content-radius h-100 d-flex flex-column pb-0'
                  style={{ backgroundColor: "#f0f0f0" }}
                >
                  {/* Single horizontal scroller so header + body stay aligned */}
                  <div
                    className='matrix-scroll w-100'
                    style={{
                      overflowX: 'auto',
                      overflowY: 'hidden',
                      WebkitOverflowScrolling: 'touch'
                    }}
                  >
                    <div className='' style={{ width: contentWidth }}>
                      <div className='w-100'>
                        {/* ======= HEADER ROW ======= */}
                        <div
                          className='w-100 d-flex'
                          style={{
                            backgroundColor: '#fff',
                            position: 'sticky',
                            top: 0,
                            zIndex: 2,
                            minHeight: 50
                          }}
                        >
                          {/* Corner (Row/Column label) */}
                          <div
                            className=''
                            style={{
                              position: isMobile ? 'static' : 'sticky',
                              left: 0,
                              zIndex: 3,
                              backgroundColor: '#fff'
                            }}
                          >
                            <div
                              className='py-1 h-100 flexc row-header'
                              style={{
                                width: rowHeaderW,
                                background: '#fcfcfc',
                                borderRight: '1px solid #eee',
                                borderBottom: '1px solid #eee'
                              }}
                            >
                              <div className='px-2 flexc' style={{ width: rowHeaderW }}>
                                <p
                                  className='text-smaller text-semibold w-100'
                                  style={{ textOverflow: 'ellipsis', overflow: 'hidden', borderBottom: '0px solid #eee' }}
                                >
                                  {checkTranslation(this.state.rowHeader?.information?.label)} / {checkTranslation(this.state.columnHeader?.information?.label)}
                                </p>
                              </div>
                            </div>
                          </div>
      
                          {/* Column headers */}
                          {columnsEntries.map(([colKey, colVal], cIdx) => (
                            <div
                              key={`col-head-${colKey}-${cIdx}`}
                              className='flexcc w-100 flex-1 py-2 px-2 matrix-cell'
                              style={{
                                backgroundColor: '#fcfcfc',
                                minWidth: colMin,
                                fontSize: fontSm,
                                borderRight: '1px solid #eee',
                                borderBottom: '1px solid #eee'
                              }}
                            >
                              <MatrixInfoCell data={[colKey, colVal]} header={this.state.columnHeader} />
                            </div>
                          ))}
                        </div>
      
                        {/* ======= BODY ROWS ======= */}
                        {rowsEntries.map(([rowKey, rowVal], rIdx) => {
                          return (
                            <div key={`row-${rowKey}-${rIdx}`} className='w-100'>
                              <div className='w-100 d-flex'>
                                {/* Row header (left sticky on desktop) */}
                                <div
                                  className=''
                                  style={{
                                    position: isMobile ? 'static' : 'sticky',
                                    left: 0,
                                    zIndex: 2,
                                    backgroundColor: '#fff'
                                  }}
                                >
                                  <div
                                    className='h-100 px-2 py-2 row-header'
                                    style={{
                                      width: rowHeaderW,
                                      fontSize: fontSm,
                                      backgroundColor: '#fcfcfc',
                                      borderRight: '1px solid #eee',
                                      borderBottom: '1px solid #eee'
                                    }}
                                  >
                                    <MatrixInfoCell data={[rowKey, rowVal]} header={this.state.rowHeader} />
                                  </div>
                                </div>
      
                                {/* Grid cells */}
                                {columnsEntries.map(([colKey], cIdx) => {
                                  const cellBucket = this.state.groups?.[colKey]?.data?.[rowKey];
                                  const records = cellBucket?.data || [];
      
                                  return (
                                    <div
                                      key={`cell-${rowKey}-${colKey}-${cIdx}`}
                                      onDragOver={this.handleDragOver}
                                      onDrop={(event) => this.handleDrop(event, [rowKey, rowVal], [colKey, this.state.columns[colKey]])}
                                      className='p-1 position-relative flex-1 py-2 matrix-cell'
                                      style={{
                                        minWidth: colMin,
                                        minHeight: isMobile ? 56 : 50,
                                        backgroundColor: "#fff",
                                        borderRight: '1px solid #eee',
                                        borderBottom: '1px solid #eee'
                                      }}
                                    >
                                      <div
                                        className='w-100 h-100 flexcc'
                                        draggable={false}
                                        style={{ background: "#fff", overflow: 'auto' }}
                                      >
                                        {records.map((record, nindex) => {
                                          if (!record) return null;
      
                                          let viewKey = 'value'; // or from this.props.view?.settings?.stacked?.viewKey
                                          viewKey = paramsToValue(null, viewKey, this.props.headers, 'Current Record', true);
                                          let text = viewKey ? getObject(record, viewKey) : 'Record';
      
                                          return (
                                            <div draggable key={record._id} className='' style={{ width: '100%' }}>
                                              <div id={record._id} className='flexcc' onClick={() => this.collaps(record._id)}>
                                                <div
                                                  className='d-flex p-2 mb-1 text-center flexcc px-4'
                                                  style={{ background: '#f5f5f5', borderRadius: 6 }}
                                                >
                                                  {/* Actions (kept for future)
                                                  {this.props.actions && (
                                                    <div className='mrd-2 flexcc' onClick={(e) => e.stopPropagation()}>
                                                      <ActionsBtn
                                                        permissions={this.props.permissions}
                                                        page={this.props.page}
                                                        applet={this.props.applet}
                                                        data={record}
                                                        index={this.props.index}
                                                        actions={this.props.actions}
                                                        actionClicked={this.actionClicked}
                                                        language={this.props.language}
                                                        currentRecord={this.props.currentRecord}
                                                        currentRecordStage={this.props.currentRecordStage}
                                                        changeRecordStage={this.props.changeRecordStage}
                                                        setCurrentRecordStage={this.props.setCurrentRecordStage}
                                                        colors={this.props.colors}
                                                        functionsHandler={this.props.functionsHandler}
                                                      />
                                                    </div>
                                                  )}
                                                  */}
                                                  <div className='text-center'>
                                                    <p className='text-small' style={{ fontSize: fontSm }}>{text}</p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                      {/* Floating cell actions button (kept in case you re-enable)
                                      <button
                                        className='position-absolute br-20 p-1'
                                        style={{ bottom: 3, right: 3, backgroundColor: "#f0f0f0" }}
                                        onClick={() => this.MatrixModal.modal.showModal()}
                                      >
                                        <img className='flexcc opacity-2' src='/assets/icons/useful/action.png' height={12} />
                                      </button>
                                      */}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
      
                {/* Drag auto-scroll indicators */}
                {this.state.draggedItem && (
                  <>
                    <div
                      onDragOver={() => this.scrollIndicatorOver('scrollLeft', -1)}
                      style={{ height: '100%', width: 140, position: 'absolute', top: 0, left: 0, zIndex: 10 }}
                    />
                    <div
                      onDragOver={() => this.scrollIndicatorOver('scrollTop', -1)}
                      style={{ height: 50, width: '100%', position: 'absolute', top: 0, left: 0, zIndex: 10 }}
                    />
                    <div
                      onDragOver={() => this.scrollIndicatorOver('scrollTop', 1)}
                      style={{ height: 40, width: '100%', position: 'absolute', bottom: 0, left: 0, zIndex: 10 }}
                    />
                    <div
                      onDragOver={() => this.scrollIndicatorOver('scrollLeft', 1)}
                      style={{ height: '100%', width: 40, position: 'absolute', top: 0, right: 0, zIndex: 10 }}
                    />
                  </>
                )}
              </>
            ) : (
              // ======= EMPTY/CONFIG STATE =======
              <div className="flexcc w-100">
                <div className="pt-5 pb-5 px-3 flexcc flex-column text-center">
                  <p className="py-1 text-bold text-big">{translate("Needs configuration")}</p>
                  <p className="py-1 text-small" style={{ maxWidth: 500 }}>
                    {translate("For using matrix view, you need to do a configuration on the fields, use the botton below to do this configuration")}
                  </p>
                  <button
                    className="p-2 px-4 br-30 mt-2 text-semibold"
                    onClick={() => this.openSelectStack()}
                    style={{ background: '#007aff', color: '#fff' }}
                  >
                    <p>{translate("Open Config")}</p>
                  </button>
                </div>
              </div>
            )}
          </div>
        );
      }



    scrollIndicatorOver = (side, value) => {

        this.mainContainer[side] = this.mainContainer[side] + value

    }


    handleDragStart = (event, item, index, row, column) => {

        // console.log(row)
        // console.log(column)
        // console.log(item)
        // console.log(index)

        this.setState({
            draggedItem: item,
            draggedIndex: index,
            draggedRow: row,
            draggedColumn: column,
        });
        // if (!this.state.verID) {
        //     this.setState({
        //         verID: ver[1].header.id,
        //         horID: hor[1].header.id,
        //     })
        // }

        // console.log(item)
        let i = document.getElementById(item._id)
        event.dataTransfer.setDragImage(i, 0, 0);

    };
    handleDragOver = (event) => {
        event.preventDefault();
    };

    handleDrop = (event, row, column) => {

        console.log("handleDrop")
        // console.log("row, ", row)
        // console.log("column, ", column)

        let draggedItem = { ...this.state.draggedItem }
        let draggedIndex = this.state.draggedIndex

        // console.log(draggedItem)
        // console.log(this.state.rowHeader)
        // console.log(this.state.columnHeader)

        let rowHeaderId = this.state.rowHeader?.key
        let colHeaderId = this.state.columnHeader?.key

        let rowNewKey = row[0] != '*undefined' ? row[0] : null
        let columNewKey = column[0] != '*undefined' ? column[0] : null


        // console.log("rowHeaderId, ", rowHeaderId)
        // console.log("colHeaderId, ", colHeaderId)


        // console.log("rowNewKey, ", rowNewKey)
        // console.log("columNewKey, ", columNewKey)


        let groups = this.state.groups

        // console.log(draggedItem)

        setObject(draggedItem, rowHeaderId, rowNewKey)
        setObject(draggedItem, colHeaderId, columNewKey)

        // console.log(draggedItem)

        // console.log("TP1")

        // return
        // draggedItem.values[this.state.verID] = row[0]
        // draggedItem.values[this.state.horID] = column[0]


        if (groups[column[0]]?.data) {

            if (!groups[column[0]].data[row[0]] || !groups[column[0]].data[row[0]].data) {
                groups[column[0]].data[row[0]] = { data: [] }
            }

            // if (groups[column[0]].data[row[0]]?.data) {
            groups[column[0]].data[row[0]].data.push(draggedItem)
            // } else {
            //     groups[row[0]].data[column[0]] = { data: [] }
            //     groups[row[0]].data[column[0]].data.push(draggedItem)
            // }
            // console.log("TP2")


        } else {

            // console.log("HEREEEE!!!")
            let data = {}
            data[row[0]] = { 'data': [] }
            groups[column[0]] = {}
            groups[column[0]]['data'] = data
            groups[column[0]].data[row[0]].data.push(draggedItem)

            // console.log("TP3")

        }

        // console.log(this.state.dragedRowKey)
        let dragedRowKey = this.state.draggedRow ? this.state.draggedRow[0] : this.state.draggedRow
        let draggedColumnKey = this.state.draggedColumn ? this.state.draggedColumn[0] : this.state.draggedColumn


        // console.log(groups)
        // console.log(dragedRowKey)
        // console.log(draggedColumnKey)

        // return

        // console.log("TP4")

        delete groups[draggedColumnKey].data[dragedRowKey].data[draggedIndex]

        // console.log("TP5")


        // data.forEach((i)=>{
        //     if (i._id === draggedItem._id){
        //         console.log('herrrrrrr',i,draggedItem)
        //         i = draggedItem
        //     }
        // })
        // console.log('herrrrrrr', data)


        // this.groupBy(0,data,this.state.key)

        // return
        this.setState({
            draggedItem: null,
            draggedIndex: null,
            draggedRow: null,
            draggedColumn: null,
            groups
        });


        this.props.submitForm(draggedItem, true)



    };
}
